"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../Button/Button");
var _close = _interopRequireDefault(require("../../assets/img/close.svg"));
require("./Modal.css");
require("./modalsAnimations.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Modal = function Modal(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "m-s" : _ref$size,
    _ref$backdropStyle = _ref.backdropStyle,
    backdropStyle = _ref$backdropStyle === void 0 ? "dark" : _ref$backdropStyle,
    _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? false : _ref$centered,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? "1" : _ref$styleType,
    animation = _ref.animation,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? "br-md" : _ref$borderRadius,
    title = _ref.title,
    paragraph = _ref.paragraph,
    logoSrc = _ref.logoSrc,
    ariaLabelledBy = _ref.ariaLabelledBy,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$closeAlign = _ref.closeAlign,
    closeAlign = _ref$closeAlign === void 0 ? "right" : _ref$closeAlign,
    _ref$closeButtonStyle = _ref.closeButtonStyleType,
    closeButtonStyleType = _ref$closeButtonStyle === void 0 ? "btn-1" : _ref$closeButtonStyle,
    closeButtonAnimation = _ref.closeButtonAnimation,
    closeButtonBorderStyle = _ref.closeButtonBorderStyle,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    children = _ref.children,
    _ref$alignTitle = _ref.alignTitle,
    alignTitle = _ref$alignTitle === void 0 ? "left" : _ref$alignTitle,
    _ref$alignParagraph = _ref.alignParagraph,
    alignParagraph = _ref$alignParagraph === void 0 ? "left" : _ref$alignParagraph;
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Escape") {
      onClose();
    }
  };
  var setFocus = function setFocus(node) {
    if (node) {
      var focusableElements = node.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length) focusableElements[0].focus();
    }
  };
  var modalSizeClass = size;
  var modalStyleClass = "modal-".concat(styleType);
  var centerClass = centered ? "m-center" : "";
  var animationClass = animation ? animation : "";
  var modalBackdropClass = "modal-container modal-backdrop-".concat(backdropStyle);
  var headerClass = logoSrc ? "modal-header" : "modal-header no-logo";
  var titleClass = title ? "modal-title t-".concat(title.size || "1", " ").concat(title.align || alignTitle) : "";
  var paragraphClass = paragraph ? "modal-paragraph p-".concat(paragraph.size || "1", " ").concat(paragraph.align || alignParagraph) : "";
  var closeButtonContainerClass = "modal-close-button-container ".concat(closeAlign === "left" ? "align-left" : closeAlign === "center" ? "align-center" : "align-right");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalBackdropClass,
    "aria-hidden": "true",
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal ".concat(modalSizeClass, " ").concat(modalStyleClass, " ").concat(centerClass, " ").concat(animationClass, " ").concat(className, " ").concat(borderRadius).trim(),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": ariaLabelledBy,
    ref: setFocus
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: headerClass
  }, logoSrc && /*#__PURE__*/_react["default"].createElement("img", {
    src: logoSrc,
    className: "modal-logo",
    alt: "Logo"
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: titleClass
  }, title.text)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-content"
  }, showCloseButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: closeButtonContainerClass
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    isCloseButton: true,
    onClick: onClose,
    size: "close",
    styleType: closeButtonStyleType,
    animation: closeButtonAnimation,
    borderStyle: closeButtonBorderStyle,
    className: "modal-close-btn"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _close["default"],
    alt: "Close"
  }))), paragraph && /*#__PURE__*/_react["default"].createElement("p", {
    className: paragraphClass
  }, paragraph.text), children)));
};
var _default = exports["default"] = Modal;